import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Transition as _Transition, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "flex justify-between items-center max-w-7xl mx-auto px-4 py-4 sm:px-6 md:justify-start md:space-x-10 lg:px-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Top O' Tobago", -1)
const _hoisted_4 = { class: "-mr-2 -my-2 md:hidden" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open menu", -1)
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "hidden md:flex items-center justify-end md:flex-1 lg:w-0" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/book",
    class: "ml-8 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-teal-500 hover:bg-teal-600"
  }, " Book online ")
], -1)
const _hoisted_8 = { class: "rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50" }
const _hoisted_9 = { class: "py-6 px-5" }
const _hoisted_10 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mt-6" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/book",
    class: "w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-teal-500 hover:bg-teal-600"
  }, " Book online ")
], -1)

import MainFooter from "../components/MainFooter.vue";

import {
  Popover,
  PopoverButton,
  PopoverGroup,
  PopoverPanel,
} from "@headlessui/vue";

import {
  MenuIcon,
  QuestionMarkCircleIcon,
  XIcon,
} from "@heroicons/vue/outline";
import { ChevronDownIcon } from "@heroicons/vue/solid";


export default /*#__PURE__*/_defineComponent({
  __name: 'default',
  setup(__props) {

const logoUrl =
  "https://res.cloudinary.com/millsit/image/upload/c_scale,w_105/v1648245957/TOT/logo_tot_v4.1_vn7cxw.png";

const navigation = [
  { name: "Home", href: "/" },
  { name: "Tobago Island", href: "/tobagoisland" },
  { name: "Top O' Tobago", href: "/topotobago" },
  { name: "Accommodation", href: "/accommodation" },
  { name: "Birds", href: "/birds" },
  { name: "Contact", href: "/contact" },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createVNode(_unref(Popover), { class: "relative bg-white" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", { class: "flex justify-start lg:w-0 lg:flex-1" }, [
              _createElementVNode("a", { href: "/" }, [
                _hoisted_3,
                _createElementVNode("img", {
                  class: "h-12 w-auto sm:h-12",
                  src: logoUrl,
                  alt: ""
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(PopoverButton), { class: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-teal-500" }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createVNode(_unref(MenuIcon), {
                    class: "h-6 w-6",
                    "aria-hidden": "true"
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(_unref(PopoverGroup), {
              as: "nav",
              class: "hidden md:flex space-x-10"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                  return _createElementVNode("a", {
                    key: item.name,
                    href: item.href,
                    class: "text-base font-medium text-gray-500 hover:text-gray-900"
                  }, _toDisplayString(item.name), 9, _hoisted_6)
                }), 64))
              ]),
              _: 1
            }),
            _hoisted_7
          ]),
          _createVNode(_Transition, {
            "enter-active-class": "duration-200 ease-out",
            "enter-from-class": "opacity-0 scale-95",
            "enter-to-class": "opacity-100 scale-100",
            "leave-active-class": "duration-100 ease-in",
            "leave-from-class": "opacity-100 scale-100",
            "leave-to-class": "opacity-0 scale-95"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(PopoverPanel), {
                focus: "",
                class: "absolute z-30 top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                          return _createElementVNode("a", {
                            key: item.name,
                            href: item.href,
                            class: "text-base font-medium text-gray-900 hover:text-gray-700"
                          }, _toDisplayString(item.name), 9, _hoisted_11)
                        }), 64))
                      ]),
                      _hoisted_12
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(MainFooter)
  ]))
}
}

})